// useLoading.js
import { useState } from 'react';

export const useLoading = (initial:boolean):any => {
    const [isLoading, setIsLoading] = useState(initial);
    return [isLoading, setIsLoading];
};
